export default __webpack_public_path__ + "static/media/curriculum-blue.49eaa991.svg";